/* Only a server-verified paid receipt can open the real post-purchase celebration. */
(()=>{'use strict';
 const endpoint=window.RAGEPAD_CONFIG?.celebrationEndpoint;if(!endpoint||window.rageReturnVerificationInstalled)return;
 let url;try{url=new URL(endpoint);if(url.protocol!=='https:'||url.username||url.password||url.search||url.hash)return;}catch{return;}
 window.rageReturnVerificationInstalled=true;
 const key='ragepad-purchase-return-v27';let activeNonce='',tries=0,displayTries=0,inFlight=false,timer,receipt;
 function read(){try{const r=JSON.parse(localStorage.getItem(key));return r&&!r.completed&&/^[a-f0-9]{64}$/.test(r.nonce)&&Number.isFinite(r.startedAt)&&r.startedAt<=Date.now()+60000&&Date.now()-r.startedAt<=72*3600000?r:null;}catch{return null;}}
 function later(){clearTimeout(timer);if(!document.hidden&&(receipt?displayTries<5:tries<5))timer=setTimeout(check,3000);}
 function show(record){
  if(!receipt||document.hidden||displayTries>=5)return;displayTries++;
  if(typeof window.rageCelebratePurchase!=='function'){later();return;}
  window.rageCelebratePurchase(receipt);record.completed=true;record.receipt=receipt.receipt;tries=5;
  try{localStorage.setItem(key,JSON.stringify(record));}catch{}
  receipt=null;clearTimeout(timer);
 }
 async function check(){
  clearTimeout(timer);if(document.hidden||inFlight)return;
  const record=read();if(!record)return;
  if(record.nonce!==activeNonce){activeNonce=record.nonce;tries=0;displayTries=0;receipt=null;}
  if(receipt){try{show(record);}catch{later();}return;}if(tries>=5)return;
  inFlight=true;tries++;
  try{
   const response=await fetch(url.href,{method:'POST',redirect:'error',referrerPolicy:'no-referrer',headers:{'Content-Type':'application/json'},credentials:'omit',body:JSON.stringify({nonce:record.nonce,startedAt:record.startedAt}),signal:AbortSignal.timeout(32000)});
   if(!response.ok){later();return;}const data=await response.json();
   if(read()?.nonce!==record.nonce)return;
   if(data.paid===true&&typeof data.receipt==='string'&&data.receipt.length>0&&data.items&&['black','white','pink'].every(c=>Number.isInteger(data.items[c])&&data.items[c]>=0&&data.items[c]<=99)&&['black','white','pink'].some(c=>data.items[c]>0)){
    receipt=data;show(record);return;
   }
   later();
  }catch{later();}finally{inFlight=false;}
 }
 window.addEventListener('pageshow',check);
 document.addEventListener('visibilitychange',()=>{if(document.hidden)clearTimeout(timer);else check();});
 window.addEventListener('pagehide',()=>clearTimeout(timer));
 if(document.readyState==='complete')check();else window.addEventListener('load',check,{once:true});
})();
